import React from "react";
import { Link } from "react-router-dom";
import { Mail, PawPrint } from "lucide-react";
import BarkLogo from "./BarkLogo";

export default function SiteFooter() {
  return (
    <footer
      className="mt-24 border-t border-white/70 bg-white/60 backdrop-blur-sm"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-6xl px-5 md:px-8 py-12 grid md:grid-cols-3 gap-10">
        <div>
          <BarkLogo size={44} />
          <p className="mt-4 text-[14px] text-bark-ink2 leading-relaxed max-w-sm">
            Bark Buddies helps dog owners find compatible nearby playmates,
            message safely, schedule meetups, and discover great dog parks.
          </p>
          <div className="mt-4 inline-flex items-center gap-2 text-[13px] text-bark-muted">
            <PawPrint size={14} className="text-bark-teal" />
            Built for dogs & their humans
          </div>
        </div>

        <div>
          <div className="text-[12px] uppercase tracking-widest font-bold text-bark-muted mb-3">
            Legal
          </div>
          <ul className="space-y-2 text-[14px] font-semibold">
            <li>
              <Link className="bark-link" to="/privacy" data-testid="footer-privacy-link">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link className="bark-link" to="/terms" data-testid="footer-terms-link">
                Terms of Service
              </Link>
            </li>
            <li>
              <Link className="bark-link" to="/support" data-testid="footer-support-link">
                Support
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-[12px] uppercase tracking-widest font-bold text-bark-muted mb-3">
            Contact
          </div>
          <a
            href="mailto:support@barkbuddies.app"
            className="inline-flex items-center gap-2 text-[14px] font-semibold text-bark-ink hover:text-bark-teal transition-colors"
            data-testid="footer-support-email"
          >
            <Mail size={16} className="text-bark-teal" />
            support@barkbuddies.app
          </a>
          <div className="mt-6 text-[12px] text-bark-muted">
            © {new Date().getFullYear()} Bark Buddies. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
